import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Inject, Input, Output, SimpleChanges, TemplateRef, ViewChild, signal } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatPaginatorIntl, MatPaginatorModule } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { MemberNotificationService } from "../../n-member/n-member.service";
import { IRequestResult } from "app/common/interfaces";
import NotificationMemberAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/notification-member.entity';
import { MatSelectModule } from "@angular/material/select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import ShortNotificationMemberAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/short-notification-member/short-notification-member.short.entity";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { GroupNotificationService } from "../../n-group/n-group.service";
import { CompanyAttributes, NotificationGroupAttributes } from "@albatrosdeveloper/ave-models-package";
import DistributionChainAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { MatRadioModule } from "@angular/material/radio";

export enum Type {
  GROUP = 0,
  MEMBER = 1
}

@Component({
  selector: "app-table-members",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIcon,
    MatSortModule,
    MatButtonModule,
    FormsModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDialogModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule
  ],
  templateUrl: "./table-members.component.html",
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }],
})

export class TableMembersComponent {
  @Input() type: 'members' | 'copyMembers' = 'members';
  @Input() companyList: CompanyAttributes[] = [];
  @Input() listDistributionChain: DistributionChainAttributes[] = [];
  //@Input() salesOfficeList: SalesOfficeAttributes[] = [];
  @Input() companyId: string | null = null; // AGREGAR ESTE INPUT
  private data!: any;
  @Input('data')
  set _data(value: any) {
    this.data = value;
  }

  @Output() membersChange: EventEmitter<any> = new EventEmitter();

  //#region Table
  public dataSourceMembers = new MatTableDataSource<any>([]);
  public displayedColumns: string[] = [
    "name",
    "email",
    "phone",
    "action"
  ];
  //#endregion

  //#region Form
  dialogRef: MatDialogRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  currentMember: {
    flagType: Type,
    currentGroup: NotificationGroupAttributes | null,
    currentMember: NotificationMemberAttributes | null
  } = {
      flagType: Type.GROUP,
      currentGroup: null,
      currentMember: null
    }

  groupList = signal<NotificationGroupAttributes[]>([]);
  groupsFilterList = signal<NotificationGroupAttributes[]>([]);
  searchGroup = ''
  groupMembersList: ShortNotificationMemberAttributes[] = []
  membersList: NotificationMemberAttributes[] = [];
  membersFilterList = signal<NotificationMemberAttributes[]>([]);
  searchMember = ''
  //#endregion

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private memberNotificationService: MemberNotificationService,
    private groupNotificationService: GroupNotificationService,
  ) {

  }

  ngOnInit(): void {
    /* Decidir qué método usar según si hay companyId
    if (this.companyId) {
      this.getGroupsByCompany(this.companyId);
    } else {
      this.getGroup(); // Usar método original
    }*/
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] || changes['type']) {
      this.initTable();
    }

    // Si cambia companyId, usar el método específico
    if (changes['companyId'] && this.companyId) {
      this.getGroupsByCompany(this.companyId);
    }


  }

  applyFilter(filterValue: string) {
    this.dataSourceMembers.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceMembers.paginator) {
      this.dataSourceMembers.paginator.firstPage();
    }
  }

  /*initTable(){
    if (this.type === 'members') {
      this.dataSourceMembers.data = this.data.members || [];
    } else if (this.type === 'copyMembers') {
      this.dataSourceMembers.data = this.data.copyMembers || [];
    }
  }*/
  initTable() {
    // Crear copias profundas para evitar referencias compartidas
    if (this.type === 'members') {
      this.dataSourceMembers.data = JSON.parse(JSON.stringify(this.data.members || []));
    } else if (this.type === 'copyMembers') {
      this.dataSourceMembers.data = JSON.parse(JSON.stringify(this.data.copyMembers || []));
    }
  }


  //#region Form   
  /*
  onFlagTypeChange(event: any) {
    const company = this.companyList.find(c => c._id === this.data.companyId);
    const distributionChain = this.listDistributionChain.find(c => c._id == this.data.distributionChainId);
    const salesOffice = this.salesOfficeList.find(c => c._id == this.data.salesOfficeId);

    if(event.value == 1){
      this.currentMember.currentGroup = null
      this.getAllMembers(company)
    }else{
      this.currentMember.currentMember = null
    } 
  }*/
  onFlagTypeChange(event: any) {
    if (event.value == 1) {
      this.currentMember.currentGroup = null;
      if (!this.data.companyId) {
        this.membersList = [];
        this.membersFilterList.update(() => []);
        return;
      }

      const company = this.companyList.find(c => c._id === this.data.companyId);
      if (company) {
        this.getAllMembers(company);
      } else {
        this.snackBar.open('No hay una compañia selesccionada.', 'Cerrar', { duration: 3000 });
      }
    } else {
      if (this.companyId) {
        this.getGroupsByCompany(this.companyId);
      } else if (this.data?.companyId) {
        this.getGroupsByCompany(this.data.companyId);
      } else {
        this.snackBar.open('No hay una compañía seleccionada para cargar grupos.', 'Cerrar', { duration: 3000 });
      }
    }
  }

  /*getGroup() {
  this.groupNotificationService.findAll().subscribe({
    next: (res: IRequestResult<NotificationGroupAttributes[]>) => {
      // Asigna la respuesta a la señal
      this.groupList.set(res.data || []);
      this.groupsFilterList.set(this.groupList().slice());
    },
    error: (err) => {
    }
  });
}
 */
  /*getGroup() {
    this.groupNotificationService.findAll().subscribe({
      next: (res: IRequestResult<NotificationGroupAttributes[]>) => {
        const activeGroups = (res.data || []).filter(g => g.statusId === 1)
          .map(g => ({
            ...g,
            members: (g.members || []).filter(m => m.statusId === 1) 
          }));
        this.groupList.set(activeGroups);
        this.groupsFilterList.set(this.groupList().slice());
      },
      error: (err) => {
      }
    });
  }*/

  /*getGroup() {
    this.groupNotificationService.findAll().subscribe({
      next: (res: IRequestResult<NotificationGroupAttributes[]>) => {
        // Filtra los grupos activos
        const activeGroups = (res.data || [])
          .filter(group => group.statusId === 1)      // solo grupos activos
          .map(group => ({
            ...group,
            members: (group.members || []).filter(m => m.statusId === 1) // solo miembros activos
          }));
  
        this.groupList.set(activeGroups);
        this.groupsFilterList.set(this.groupList().slice());
      },
      error: (err) => {
        this.snackBar.open('Error.', 'Cerrar', { duration: 3000 });
      }
    });
  }*/

  getGroupsByCompany(companyId: string) {
    this.groupNotificationService.getAllPaginate(
      {
        currentPage: 1,
        limitPerPage: Number.MAX_SAFE_INTEGER,
        sort: "name",
        sortDirection: "ASC"
      },
      {
        companyId: Number(companyId),
        status: [1]
      }
    ).subscribe({
      next: (res) => {
        const groups = res?.data?.[0]?.data ?? [];
        const activeGroups = groups.map(group => ({
          ...group,
          members: (group.members || []).filter(m => m.statusId === 1)
        }));

        this.groupList.set(activeGroups);
        this.groupsFilterList.set(this.groupList().slice());
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al obtener los grupos.', 'Cerrar', { duration: 3000 });
      }
    });
  }



  /*
   getGroup(){
    this.groupNotificationService.findAll().subscribe({
      next: (res: IRequestResult<NotificationGroupAttributes[]>) => {
        this.groupList = res.data;
        this.groupsFilterList.update(() => this.groupList.slice());
      },
      error: (err) => {
      }
    })
  }*/

  /*changueOptionsGroup(event){
    if (!this.groupList) {
      return;
    }
    let search = event;
    if (!search) {
      this.groupsFilterList.update(() => this.groupList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.groupsFilterList.update(() => this.groupList.filter(item => item.name.toLowerCase().indexOf(search) > -1))
  }*/
  changueOptionsGroup(event) {
    const currentGroups = this.groupList();
    if (!currentGroups || currentGroups.length === 0) {
      return;
    }

    let search = event;
    if (!search) {
      this.groupsFilterList.set(currentGroups.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.groupsFilterList.set(
      currentGroups.filter(item =>
        item.name?.toLowerCase().indexOf(search) > -1
      )
    );
  }

  getGroupMembers() {
    this.groupNotificationService.getMembersByGroupId(this.data._id.toString()).subscribe({
      next: (res: IRequestResult<ShortNotificationMemberAttributes[]>) => {
        this.groupMembersList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error no hay miembros.', 'Cerrar', { duration: 3000 });
      }
    });
  }

  getAllMembers(company): void {

    if (company) {
      let dataToFilter = {
        companyId: company._id,
      }

      this.memberNotificationService.getCombo(dataToFilter).subscribe({
        next: (res: IRequestResult<NotificationMemberAttributes[]>) => {

          this.membersList = res.data;

          this.membersFilterList.update(() => this.membersList.slice());
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'No se encontraron los miembros.', 'Cerrar', { duration: 3000 });

        }
      });
    } else {
      this.snackBar.open('No hay compañia seleccionada.', 'Cerrar', { duration: 3000 });
    }
  }

  changueOptionsMember(event) {
    if (!this.membersList) {
      return;
    }
    let search = event;
    if (!search) {
      this.membersFilterList.update(() => this.membersList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.membersFilterList.update(() => this.membersList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1))
  }

  /*addMembers(){
    let membersAux = this.dataSourceMembers.data.slice();
    
    if(this.currentMember.flagType == Type.GROUP){
      const newMembers = this.currentMember.currentGroup.members.filter(
        m => !membersAux.some(existing => existing._id === m._id)
      );

      if (newMembers.length === 0) {
        this.snackBar.open('Todos los miembros del grupo ya existen en la lista.', 'Cerrar', { duration: 3000 });
        return;
      }

      membersAux.push(...newMembers)
    }else{
      if (membersAux.some(m => m._id.toString() === this.currentMember.currentMember._id)) {
        this.snackBar.open('El correo ya existe en la lista.', 'Cerrar', { duration: 3000 });
        return;
      }
      membersAux.push(this.currentMember.currentMember)
    }
    this.dataSourceMembers.data = membersAux
    this.resetFormAddMember()
    this.saveGlobal()
  }*/
  addMembers() {
    // Crear una copia profunda del array actual
    let membersAux = JSON.parse(JSON.stringify(this.dataSourceMembers.data));

    if (this.currentMember.flagType == Type.GROUP) {
      // Crear copias profundas de los nuevos miembros también
      const newMembers = JSON.parse(JSON.stringify(
        this.currentMember.currentGroup.members.filter(
          m => !membersAux.some(existing => existing._id === m._id)
        )
      ));

      if (newMembers.length === 0) {
        this.snackBar.open('Todos los miembros del grupo ya existen en la lista.', 'Cerrar', { duration: 3000 });
        return;
      }

      membersAux.push(...newMembers);
    } else {
      if (membersAux.some(m => m._id.toString() === this.currentMember.currentMember._id)) {
        this.snackBar.open('El correo ya existe en la lista.', 'Cerrar', { duration: 3000 });
        return;
      }
      // Crear copia profunda del miembro individual
      membersAux.push(JSON.parse(JSON.stringify(this.currentMember.currentMember)));
    }

    this.dataSourceMembers.data = membersAux;
    this.resetFormAddMember();
    this.saveGlobal();
  }

  resetFormAddMember() {
    this.currentMember = {
      flagType: Type.GROUP,
      currentGroup: null,
      currentMember: null
    }
  }

  openDeleteDialog(member: NotificationMemberAttributes | ShortNotificationMemberAttributes, index: number): void {
    this.dialog
      .open(this.deleteDialog, { data: member, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(member));
  }

  /*delete(memberToDelete: NotificationMemberAttributes | ShortNotificationMemberAttributes) {
    const membersAux = this.dataSourceMembers.data.filter(m => m._id !== memberToDelete._id);
    this.dataSourceMembers.data = membersAux;
    this.saveGlobal();
  }*/
  delete(memberToDelete: NotificationMemberAttributes | ShortNotificationMemberAttributes) {
    // Crear una copia profunda del array filtrado
    const membersAux = JSON.parse(JSON.stringify(
      this.dataSourceMembers.data.filter(m => m._id !== memberToDelete._id)
    ));
    this.dataSourceMembers.data = membersAux;
    this.saveGlobal();
  }

  /*saveGlobal(){
    this.membersChange.emit({
    type: this.type,
    members: this.dataSourceMembers.data
  });
  }*/
  saveGlobal() {
    // Crear una copia profunda de los datos antes de emitir
    const membersCopy = JSON.parse(JSON.stringify(this.dataSourceMembers.data));

    this.membersChange.emit({
      type: this.type,
      members: membersCopy
    });
  }


  //#endregion
}

